<div class="layout-row layout-align-start-center"
     [ngbTooltip]="tooltipTmpl" openDelay="300" triggers="hover"  placement="top-start"
     [disableTooltip]="isDisableTooltip"
     container="body"
     (mouseenter)="isShowActions=true"
     (mouseleave)="isShowActions=false">


  <app-bringoz-state-link class="text-ellipsis"
                          [permission]="'accounts.demand.get'"
                          [state]="'accounts-detail-demand.info.preferences'"
                          [params]="{id: account.id}"
                          [text]="account.name">
  </app-bringoz-state-link>

  <app-text-copy-button *ngIf="isAllowCopyButton && isShowActions" [text]="account.name"
                        [isShowCopyBtn]="isShowActions"></app-text-copy-button>

  <bringoz-button *ngIf="isShowFilterByButton && isShowActions"
                  type="tertiary" size="fit"
                  (onClick)="filterByTypeEvent($event)">
    <bringoz-icon iconName="filter"></bringoz-icon>
  </bringoz-button>

</div>

<ng-template #tooltipTmpl>
  <div class="layout-column">
    <span class="br-body-2">{{account.name}}</span>
    <span *ngIf="address">{{address | bringozAddress}}</span>
  </div>
</ng-template>
